<template>
  <div class="Estimation">
    <div class="page-title">{{ $t("title.estimation") }}</div>
    <div>
      <ATable
        ref="table"
        max-height="750px"
        :data="items"
        :loading="loading"
        :placeholder="placeholder"    
        :search_field="search_field"
        :disable_insert="!has_grant_write"
        hide-pagination
        border
        @row-click="handleClickRow"
        @clicked-create="handleClickedCreate"
      >
        <div slot="search">
          <div class="inline">
            <APeriodSelector ref="period" @change="handleChangePeriod" />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
            >검색(F5)</el-button>
          </div>
        </div>
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          align="center"
          :width="$width.index"
        />
        <el-table-column prop="code" label="견적번호" align="center" width="100" />
        <el-table-column prop="customer_name" label="거래처" width="150" show-overflow-tooltip />
        <el-table-column prop="location" label="사업장" width="120" show-overflow-tooltip />
        <el-table-column prop="product_name" label="품목" show-overflow-tooltip />
        <el-table-column prop="status_flag" label="상태" align="center" width="60">
          <template slot-scope="scope">{{resolveStatus(scope.row.status_flag)}}</template>
        </el-table-column>
        <el-table-column
          prop="price"
          label="견적가"
          class-name="cell-number"
          width="100"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="estimate_date"
          label="견적일"
          :width="$width.date"
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
      </ATable>
    </div>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      :width="showPyungProcessingCost ? '1500px' : '1300px'"
      title="견적"
      :visible.sync="dialogVisible"
      destroyOnClose
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <EstimationForm 
        ref="form" 
        :data="form_data" 
        :has_grant_write="has_grant_write"
        @completed="handleCompleted" 
      />
    </el-dialog>
  </div>
</template>
<script>
// import { mapGetters } from "vuex";
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import { company_info } from "@/common/mixins/company_info";
import EstimationForm from "./EstimationForm";

export default {
  name: "Estimation",
  mixins: [form_container, authority_level, company_info],
  components: { EstimationForm },
  data() {
    return {
      company: {
        show_pyung_processing_cost: false
      },
      search_field: ["code", "customer_name", "product_name"],
      placeholder: '견적번호,거래처, 품목',
      collapse: "",
      search: {
        keyword: "",
        status: []
      },
      period: {},
      items: [],
      statuses: [
        { value: "0", label: "견적" },
        { value: "1", label: "수주" },
        { value: "2", label: "취소" }
      ],
      isShowSearchDetail: false,
      loading: false,
      dialogVisible: false,
      form_data: undefined
    };
  },
  computed: {
    // ...mapGetters(["table_product"]),
    showPyungProcessingCost() {
      return this.company.show_pyung_processing_cost;
    },
    searchTags: function() {
      let tags = [];
      let tag = {};
      tag.name = this.util.getPeriodText(this.search.period);
      tag.fixed = true;
      tags.push(tag);
      if (this.search.keyword.length > 0) {
        tag = {};
        tag.name = "검색어: " + this.search.keyword;
        tags.push(tag);
      }
      if (this.search.status.length > 0) {
        tag = {};
        tag.name = "상태: " + this.search.keyword;
        tags.push(tag);
      }
      return tags;
    },
    has_grant_write() {
      return this.isWriteLevel('estimation');
    },
  },
  watch: {
    table_config() {
      this.loadConfig()
    },
  },
  mounted() {
    this.loadConfig()
    this.$nextTick(() => this.handleClickSearch());
  },
  methods: {
    handleChangePeriod(value) {
      this.period = value;
    },
    handleSearchDetail() {
      this.isShowSearchDetail = !this.isShowSearchDetail;
      if (!this.isShowSearchDetail) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.keyword.$refs.input.focus();
      });
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.loadData();
    },
    handleClickedCreate() {
      this.form_data = undefined; //추가생성시 초기화
      this.EventBus.$emit("ACustomerSelector", 1);
      this.EventBus.$emit("ATradeTable", undefined);
      this.dialogVisible = true;
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickRow(data) {
      this.openDialog(data);
    },
    handleCompleted(action, message) {
      this.dialogVisible = false;
      this.form_data = undefined;
      switch (action) {
        case "create":
        case "delete":
          this.handleClickSearch();
          this.$refs.table.initCurrentPage();
          break;
        case "update":
          this.loadData();
          break;
      }
      if (!message) {
        return;
      }
      this.$notify(message);
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.api.listEstimation(this.period).then(res => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, "견적", res.message);
          return;
        }
        this.items = res.data;
        this.items.forEach(item => {
          item.product_name = this.productNaming(item);
        })
      });
    },
    /** 다이얼로그 팝업 */
    openDialog(data) {
      let clone = data ? Object.assign({}, data) : undefined;
      this.form_data = clone;
      this.dialogVisible = true;
      this.EventBus.$emit("ATradeTable", clone.details);
    },
    resolveStatus(value) {
      let ret = "";
      switch (value) {
        case "0":
          ret = "견적";
          break;
        case "1":
          ret = "수주";
          break;
        case "2":
          ret = "취소";
          break;
      }
      return ret;
    },
    productNaming(item) {
      if (item.details.length > 1) {
        return item.details[0].product_name + " 외 " + (item.details.length - 1) + "건";
      } else {
        return item.details[0].product_name;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.el-collapse {
  border: none;
}

.el-collapse-item__header {
  > .el-tag,
  .el-button {
    margin-right: 10px;
  }
}

.search-keyword {
  width: 300px;
  margin-right: 20px;
}

.search-status {
  width: 200px;
  margin-right: 20px;
}
</style>
